'use client';
import React from 'react';
import { StyleTitleProposition } from './titlePropositions.styles';

export const TitlePropositions = () => {
	return (
		<StyleTitleProposition>
			<h2>Just Pick, Customize, and Design</h2>
		</StyleTitleProposition>
	);
};
